"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppMenu = exports.curateRoutes = void 0;
var _react = require("react");
var _context = require("../context");
var mapRoute = function mapRoute(route, context, tenantId) {
  if (route.path) {
    return Object.assign(Object.assign({}, route), {
      path: context.fixPath(route.path, tenantId)
    });
  }
  return route;
};
var routeFilter = function routeFilter(context, route) {
  return (!route.grants || context.isGrantedAny(route.grants)) && (!route.exclude || !context.isGrantedAny(route.exclude));
};
var _curateRoutes = exports.curateRoutes = function curateRoutes(context, routes, tenantId) {
  var curated = routes.filter(function (route) {
    return routeFilter(context, route);
  }).map(function (route) {
    return mapRoute(route, context, tenantId);
  }).map(function (route) {
    if (route.items && route.items.length > 0) {
      var curatedItems = _curateRoutes(context, route.items, tenantId);
      return Object.assign(Object.assign({}, route), {
        items: curatedItems
      });
    }
    return route;
  });
  return curated;
};
var useAppMenu = exports.useAppMenu = function useAppMenu(routes, tenantId) {
  var context = (0, _react.useContext)(_context.AppContext);
  var curated = _curateRoutes(context, routes, tenantId);
  var mappings = (0, _react.useMemo)(function () {
    var filtered = [];
    curated.forEach(function (route) {
      var _a;
      if (route.path) {
        filtered.push(route);
      }
      (_a = route.items) === null || _a === void 0 ? void 0 : _a.filter(function (subroute) {
        return !!subroute.path;
      }).forEach(function (subroute) {
        filtered.push(subroute);
      });
    });
    return filtered;
  }, [curated]);
  var fixedRoute = (0, _react.useMemo)(function () {
    return mappings.filter(function (el) {
      return !el.hidden;
    }).find(function (el) {
      return el.path && el.path.indexOf(':') === -1;
    });
  }, [mappings]);
  // primera ruta visible y sin parámetros
  var redirectTo = (0, _react.useMemo)(function () {
    return (fixedRoute === null || fixedRoute === void 0 ? void 0 : fixedRoute.path) || '/';
  }, [fixedRoute]);
  var appMenuState = (0, _react.useMemo)(function () {
    return {
      mappings: mappings,
      redirectTo: redirectTo
    };
  }, [mappings, redirectTo]);
  return appMenuState;
};